import { z } from "zod";
import { validationMessages } from "./validationMessages";

export const emailValidation = z.union([
  z.string().email({ message: validationMessages.email }),
  z.literal(''),
  z.undefined(),
  z.null()
]).optional();

export const createStringValidation = (min?: number, max?: number) => {
  let validation = z.string();
  
  if (min !== undefined) {
    validation = validation.min(min, { message: validationMessages.min.string(min) });
  }
  
  if (max !== undefined) {
    validation = validation.max(max, { message: validationMessages.max.string(max) });
  }
  
  return validation;
};

export const createNumberValidation = (min?: number, max?: number) => {
  let validation = z.number();
  
  if (min !== undefined) {
    validation = validation.min(min, { message: validationMessages.min.number(min) });
  }
  
  if (max !== undefined) {
    validation = validation.max(max, { message: validationMessages.max.number(max) });
  }
  
  return validation;
}; 